/**
 * Named typographic styles from the Valet Manager styleguide (Figma). Each is a Tailwind
 * class-string preset so the style can be applied via `cn()` / `className` anywhere — including
 * `<Text className={labelEmphasized}>`. Color is intentionally NOT baked in (it is not part of the
 * type style); pair each with a `tw:text-*` token at the call site.
 */

/**
 * Label Emphasized — Roboto Medium, 14px, 100% line-height, letter-spacing 0.
 *
 * Figma text style "Label Emphasized" (Valet-Manager file, e.g. node 14647-25212 "Select stay").
 * Use for the primary label in a selectable row/cell (duration name, option title).
 */
export const labelEmphasized = 'tw:text-14 tw:font-medium tw:leading-1';
